export const carousel = translate => ({
  from: { position: 'absolute', x: `${-translate}%`, opacity: '0' },
  enter: { position: 'relative', x: '0', opacity: '1' },
  leave: { position: 'absolute', x: `${translate}%`, opacity: '0' },
  config: { tension: 160, friction: 30 }
});
